<script>
/**
 * The Scene class acts as the container instance to support the 
 * TBS Scene plugin for the scene view. It introduces the 
 * scene-based development pattern for the whole application
 * or scoped view.
 */

//--------------------------------------------------
// imported classes
//--------------------------------------------------
import Vue from 'vue'
import { Dialog, Toast, NavBar } from 'vant'
import AbastractScene from '@/fcl/tbs/core/AbstractScene.vue'
import GlobalFunc from '@/fcl/tbs/util/GlobalFunc'
import { AppType } from '@/fcl/utils'
import { goLogin, setTitle } from '@/fcl/libs/ds-bridge'

//--------------------------------------------------
// global registration
//--------------------------------------------------
Vue.use(Dialog, Toast)

//--------------------------------------------------
// main script
//--------------------------------------------------
export default {
    //--------------------------------------------------
	// component extends
	//--------------------------------------------------
    extends: AbastractScene,

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-nav-bar': NavBar
    },

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
	data() {
		return {
            /* The nav bar title string*/
            navBarTitle: null,
            showNavBar: true
		}
	},

    //--------------------------------------------------
    // component life cycle trigger
    //--------------------------------------------------

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the nav bar title label.
         */
        title() {
            return this.navBarTitle ? this.navBarTitle : ''
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        //--------------------------------------------------
        // handler method
        //--------------------------------------------------

        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Init the environment globally.
         */
        init() {
            // set the native title empty to hide the navbar within app
            setTitle("")
            // @compatible-code Try to fix the page offset issue while input via soft keyboard on iOS.
            if (AppType.isInIOS) {
                let scrollY = window.scrollY
                document.addEventListener('focusin', function() {
                    scrollY = window.scrollY
                })
                document.addEventListener('focusout', function() {
                    setTimeout(function() {
                        window.scrollTo({
                            top: scrollY,
                            behavior: "smooth"
                        });
                    }, 100)
                })
            }
        },
        validateTitle(title) {
            if (this.navBarTitle != title) {
                this.navBarTitle = title
            }
        },
        validateProperties(properties) {
            // validate the passport property
            if (properties.login == 'app') {
                // console.log('@login app', this.$route.query.passport, GlobalFunc.getCookie('passport'))
                if (!this.$route.query.passport && !GlobalFunc.getCookie('passport')) {
                    console.log('no passport condition, then go login page')
                    return goLogin()
                }
                else if (this.$route.query.passport && !GlobalFunc.getCookie('passport')) {
                    GlobalFunc.setCookie('passport', this.$route.query.passport)
                }
            }
            // validate the hideNavBar property
            if (properties.hideNavBar) {
                // hide the nav bar via hideNavBar property within the meta
                this.showNavBar = false
            }
            else {
                // show the nav bar if title existed
                this.showNavBar = true
            }
        },
    }
}
</script>

<template>
    <!-- component -->
    <div class="scene-wrapper">
        <div class="scene">
            <!-- nav bar -->
            <div class="header" v-if="showNavBar">
                <van-nav-bar 
                    :title="title"
                    :fixed="true"
                    :safe-area-inset-top="true"
                    class="nav-bar"
                    left-arrow  
                    @click-left="onBackBtnClick"
                />
            </div>
            <!-- router view as scene view -->
            <router-view
                class="scene-view"
                :key="Date.now()" 
                ref="sceneView" 
                @custom-event="onCustomEvent" 
            />
        </div>
    </div>
</template>

<style src="../../fcl/tbs/stylesheet/common.css"/>
<style src="../../fcl/tbs/stylesheet/iconfont.css"/>
<style>
 body {
    background: #DBEBFA;
}
</style>